import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LabelItem from '../LabelItem';
import ListItem from '../ListItem';
import { ReactComponent as HelpIcn } from '../../../../icons/help-icon.svg';
import getColorClasses from '../../lib/getColorClasses';

const Help = ({ currentPath }) => {
  const { t } = useTranslation('PAGES');
  const validPaths = ['/app/help'];

  return (
    <ListItem>
      <Link to="/app/help" className="flex">
        <HelpIcn className={getColorClasses(currentPath, validPaths)} />
        <LabelItem className={getColorClasses(currentPath, validPaths)}>{t('HELP')}</LabelItem>
      </Link>
    </ListItem>
  );
};

export default Help;
